import { useEffect } from 'react';
import { X, AlertTriangle, CheckCircle2, Loader2 } from 'lucide-react';

// Plein écran sombre (au-dessus du bandeau PWA) pour les étapes de prise de vue
export const PleinEcran = ({ titre, sousTitre, onClose, children, actions, testId }) => {
  useEffect(() => {
    const touche = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', touche);
    return () => window.removeEventListener('keydown', touche);
  }, [onClose]);
  return (
  <div className="fixed inset-0 z-[10001] flex flex-col bg-[#0F172A] text-white" data-testid={testId}>
    <div className="flex items-start gap-3 border-b border-white/10 px-4 py-3">
      <div className="min-w-0 flex-1">
        <p className="font-display text-lg font-semibold leading-tight">{titre}</p>
        {sousTitre && <p className="text-xs text-white/60">{sousTitre}</p>}
      </div>
      <button type="button" onClick={onClose} className="rounded-full p-2 hover:bg-white/10" aria-label="Fermer" data-testid="scan-fermer"><X className="h-5 w-5" /></button>
    </div>
    <div className="flex flex-1 flex-col items-center justify-center overflow-auto p-4">{children}</div>
    {actions && <div className="flex flex-wrap justify-center gap-2 border-t border-white/10 px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">{actions}</div>}
  </div>
  );
};

export const Alertes = ({ alertes }) => (alertes.length === 0 ? (
  <p className="flex items-center gap-2 rounded-lg bg-emerald-500/15 px-3 py-2 text-sm text-emerald-300" data-testid="scan-qualite-ok"><CheckCircle2 className="h-4 w-4" /> Qualité correcte : net, lumineux, sans reflet.</p>
) : (
  <ul className="space-y-1 rounded-lg bg-amber-400/15 px-3 py-2 text-sm text-amber-200" data-testid="scan-alertes">
    {alertes.map((a) => <li key={a} className="flex gap-2"><AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" /> {a}</li>)}
  </ul>
));

export const Traitement = ({ texte = 'Transformation en scan…' }) => (
  <p className="flex items-center gap-2 text-white/80" data-testid="scan-traitement"><Loader2 className="h-5 w-5 animate-spin text-[#8DC63F]" /> {texte}</p>
);

export const tailleKo = (octets) => `${Math.max(1, Math.round(octets / 1024))} Ko`;
